// src/components/ScrollToTop.js
import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const { pathname } = useLocation();
  const initialLoadRef = useRef(true);

  useEffect(() => {
    // Function to scroll to top
    const scrollToTop = (behavior = 'instant') => {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: behavior
      });
    };

    // Immediate scroll (synchronous)
    scrollToTop('instant');

    // Scroll again after a microtask (after DOM updates)
    Promise.resolve().then(() => {
      scrollToTop('instant');
    });

    // Scroll after a small delay (for images and heavy content)
    const timer1 = setTimeout(() => {
      scrollToTop('instant');
    }, 50);

    // Scroll after another delay (for lazy-loaded content)
    const timer2 = setTimeout(() => {
      scrollToTop('instant');
    }, 150);

    // Scroll after content is fully loaded
    const handleLoad = () => {
      scrollToTop('instant');
    };
    window.addEventListener('load', handleLoad);

    // Scroll after images are loaded
    const images = document.querySelectorAll('img');
    let loadedImages = 0;
    const totalImages = images.length;

    const handleImageLoad = () => {
      loadedImages++;
      if (loadedImages === totalImages) {
        scrollToTop('instant');
      }
    };

    images.forEach(img => {
      if (img.complete) {
        loadedImages++;
      } else {
        img.addEventListener('load', handleImageLoad);
        img.addEventListener('error', handleImageLoad); // Handle broken images
      }
    });

    return () => {
      clearTimeout(timer1);
      clearTimeout(timer2);
      window.removeEventListener('load', handleLoad);
      images.forEach(img => {
        img.removeEventListener('load', handleImageLoad);
        img.removeEventListener('error', handleImageLoad);
      });
    };
  }, [pathname]);

  return null;
};

export default ScrollToTop;